<script setup lang="ts">
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from "@headlessui/vue";
import {
    colors,
    primaryColors,
    grayColors,
    PrimaryColor,
    GrayColor,
} from "./colors";
import { Check } from "lucide-vue-next";

const primaryColor = defineModel<PrimaryColor>("primary", {
    default: "red",
});

const grayColor = defineModel<GrayColor>("gray", {
    default: "slate",
});
</script>
<template>
    <div class="flex flex-col gap-5">
        <div>
            <p class="mb-2 text-lg font-medium">
                {{ $t("appearances.color_picker.primary") }}
            </p>

            <RadioGroup
                v-model="primaryColor"
                :default-value="primaryColor"
                class="mt-2"
            >
                <RadioGroupLabel class="sr-only">{{
                    $t("configurator.choose_border_radius")
                }}</RadioGroupLabel>
                <div class="flex flex-wrap gap-2">
                    <RadioGroupOption
                        v-for="option in primaryColors"
                        :key="option"
                        v-slot="{ active, checked }"
                        as="template"
                        :value="option"
                    >
                        <RadioGroupLabel
                            class="flex h-8 w-8 rounded-md shadow-xs"
                            :class="[
                                active
                                    ? 'ring-2  ring-iron-700 ring-offset-2'
                                    : '',
                                checked
                                    ? 'bg-black text-white hover:bg-iron-800'
                                    : 'text-iron-900 hover:bg-iron-50',
                                'flex items-center justify-center rounded-md  text-sm font-semibold',
                            ]"
                            :style="{
                                backgroundColor: colors[option][500],
                            }"
                        >
                            <Check v-if="checked" :size="20" />
                        </RadioGroupLabel>
                    </RadioGroupOption>
                </div>
            </RadioGroup>
        </div>
        <div>
            <p class="mb-1 text-lg font-medium">
                {{ $t("appearances.color_picker.gray") }}
            </p>
            <div class="flex flex-wrap gap-3">
                <RadioGroup v-model="grayColor" :default-value="grayColor">
                    <RadioGroupLabel class="sr-only">{{
                        $t("configurator.choose_border_radius")
                    }}</RadioGroupLabel>
                    <div class="flex flex-wrap gap-2">
                        <RadioGroupOption
                            v-for="option in grayColors"
                            :key="option"
                            v-slot="{ active, checked }"
                            as="template"
                            :value="option"
                        >
                            <RadioGroupLabel
                                class="h-8 w-8 rounded-md shadow-xs"
                                :class="[
                                    active
                                        ? 'ring-2 ring-iron-700 ring-offset-2'
                                        : '',
                                    checked
                                        ? 'bg-black text-white  hover:bg-iron-800'
                                        : 'text-iron-900 hover:bg-iron-50',
                                    'flex items-center justify-center rounded-md   text-sm font-semibold',
                                ]"
                                :style="{
                                    backgroundColor: colors[option][500],
                                }"
                            >
                                <Check v-if="checked" :size="20" />
                            </RadioGroupLabel>
                        </RadioGroupOption>
                    </div>
                </RadioGroup>
            </div>
        </div>
    </div>
</template>
